/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Digest_Email_WhenInputs */

const en_platform_digest_email_when = /** @type {(inputs: Platform_Digest_Email_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email · 8:00`)
};

const pl_platform_digest_email_when = /** @type {(inputs: Platform_Digest_Email_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail · 8:00`)
};

/**
* | output |
* | --- |
* | "Email · 8:00" |
*
* @param {Platform_Digest_Email_WhenInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_digest_email_when = /** @type {((inputs?: Platform_Digest_Email_WhenInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Digest_Email_WhenInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_digest_email_when(inputs)
	return en_platform_digest_email_when(inputs)
});